import { jsonFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { API_BASE_URL } from "../urls.api";

const NOTIFICATIONS_URL = `${API_BASE_URL}/notifications`;

export type PushPermissionState = "granted" | "denied" | "default";

export type PushPreferences = {
  pushNotificationsEnabled: boolean;
};

type ApiResponse<T> = { data: T };

export const getPushPreferences = async (): Promise<PushPreferences> => {
  const response = await jsonFetch<ApiResponse<PushPreferences>>(
    `${NOTIFICATIONS_URL}/preferences?_=${Date.now()}`,
    {
      cache: "no-store",
    }
  );
  return response.data;
};

export const updatePushPreferences = async (
  pushNotificationsEnabled: boolean
): Promise<PushPreferences> =>
  jsonFetch<ApiResponse<PushPreferences>>(`${NOTIFICATIONS_URL}/preferences`, {
    method: API_METHODS.PATCH,
    body: JSON.stringify({ pushNotificationsEnabled }),
  }).then((response) => response.data);

export const registerPushToken = async (
  token: string,
  platform: "web" | "android" | "ios",
  deviceId: string,
  permission: NotificationPermission
): Promise<void> => {
  await jsonFetch<Record<string, unknown>>(`${NOTIFICATIONS_URL}/register-token`, {
    method: API_METHODS.POST,
    body: JSON.stringify({ token, platform, deviceId, permission }),
  });
};

export const unregisterPushToken = async (token: string): Promise<void> => {
  await jsonFetch<Record<string, unknown>>(`${NOTIFICATIONS_URL}/unregister-token`, {
    method: API_METHODS.DELETE,
    body: JSON.stringify({ token }),
  });
};
